import { render, staticRenderFns } from "./MoveOuterVaccinationArea.vue?vue&type=template&id=58d19a42&"
import script from "./MoveOuterVaccinationArea.vue?vue&type=script&lang=js&"
export * from "./MoveOuterVaccinationArea.vue?vue&type=script&lang=js&"
import style0 from "./MoveOuterVaccinationArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports